import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE, authHeaders } from '../../utils/Utils.js';
import ErrorMessage from '../../shared/ErrorMessage.js';

const AddRanch = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [nickname, setNickname] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setError('');
    setLoading(true);

    fetch(`${API_BASE}/api/ranches`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ name: name.trim(), address: address.trim(), nickname: nickname.trim() }),
    })
      .then(r => {
        if (r.ok) { onSuccess?.(); return; }
        throw new Error(t('error_adding'));
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <form className="DataCollectionAdd" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder={t('ranch_name')}
        value={name}
        onChange={e => setName(e.target.value)}
        required
        maxLength={80}
      />
      <input
        type="text"
        placeholder={t('address')}
        value={address}
        onChange={e => setAddress(e.target.value)}
        maxLength={120}
      />
      <input
        type="text"
        placeholder={t('ranch_nickname_placeholder')}
        value={nickname}
        onChange={e => setNickname(e.target.value)}
        maxLength={20}
      />
      <p className="settings-hint">{t('ranch_nickname_hint')}</p>
      <button type="submit" disabled={loading || !name.trim()}>
        {loading ? t('loading') + '...' : t('add_button')}
      </button>
      <ErrorMessage message={error} />
    </form>
  );
};

export default AddRanch;
